<template>
    <div class="srv-ident">
        <header class="srv-head">
            <div class="srv-ident-logo"><i class="ri-restaurant-2-line"></i></div>
            <div>
                <div class="srv-head-titre">HSIGCOM Serveur</div>
            </div>
        </header>

        <div class="srv-corps">
            <div class="srv-ident-illu"><i class="ri-qr-scan-2-line"></i></div>

            <h1 class="srv-ident-h1">Présentez-vous à la caisse</h1>
            <p class="srv-ident-sous">
                Votre prise de service est délivrée par le caissier. Il vous
                identifie et affiche un code à scanner.
            </p>

            <ol class="srv-etapes">
                <li>
                    <span class="srv-etape-n">1</span>
                    <span>Rendez-vous à la caisse et demandez votre prise de service.</span>
                </li>
                <li>
                    <span class="srv-etape-n">2</span>
                    <span>Le caissier vous sélectionne et affiche un code QR.</span>
                </li>
                <li>
                    <span class="srv-etape-n">3</span>
                    <span>Scannez-le avec l'appareil photo de votre téléphone.</span>
                </li>
            </ol>

            <div class="srv-ident-note">
                <i class="ri-shield-check-line"></i>
                <span>Votre service reste ouvert sur ce téléphone jusqu'à sa clôture.</span>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    /**
     * Écran d'attente d'enrôlement.
     *
     * Ce composant était un formulaire où le serveur saisissait lui-même nom,
     * prénom, code et téléphone. Deux raisons de l'avoir supprimé :
     *
     *  - aucun contrôle : n'importe qui pouvait se déclarer n'importe qui ;
     *  - aucun rattachement : ces champs n'ont pas de logement en base, si bien
     *    que les commandes ne portaient pas de collaborateur réel et ne
     *    remontaient dans aucun rapport de CA.
     *
     * L'identité vient désormais du QR délivré par la caisse, qui désigne un
     * enregistrement `cltfrs` existant. Cet écran ne fait donc plus rien
     * d'autre qu'expliquer la marche à suivre - il n'émet aucun événement.
     */
    export default {
        name: "srvidentification",
    };
</script>

<style scoped>
    .srv-ident { display: flex; flex-direction: column; min-height: 100vh; }

    .srv-ident-logo {
        width: 36px; height: 36px; border-radius: 50%;
        display: flex; align-items: center; justify-content: center;
        background: rgba(255, 255, 255, .18); color: var(--srv-on-primary); font-size: 20px;
    }

    .srv-ident-illu {
        display: flex; align-items: center; justify-content: center;
        width: 84px; height: 84px; margin: var(--srv-lg) auto var(--srv-md);
        border-radius: 50%;
        background: var(--srv-primary-soft); color: var(--srv-primary);
        font-size: 40px;
    }

    .srv-ident-h1 {
        margin: 0 0 var(--srv-sm);
        font-size: 22px; font-weight: 700; text-align: center;
    }
    .srv-ident-sous {
        margin: 0 0 var(--srv-lg);
        font-size: 15px; line-height: 22px; text-align: center;
        color: var(--srv-on-variant);
    }

    .srv-etapes { list-style: none; margin: 0; padding: 0; }
    .srv-etapes li {
        display: flex; align-items: flex-start; gap: 12px;
        padding: 14px; margin-bottom: var(--srv-sm);
        background: var(--srv-surface);
        border: 1px solid var(--srv-outline-variant);
        border-radius: var(--srv-r);
        font-size: 14px; line-height: 20px;
    }
    .srv-etape-n {
        width: 26px; height: 26px; border-radius: 50%; flex-shrink: 0;
        display: flex; align-items: center; justify-content: center;
        background: var(--srv-primary); color: var(--srv-on-primary);
        font-size: 13px; font-weight: 800;
    }

    .srv-ident-note {
        display: flex; align-items: center; gap: 10px;
        margin-top: var(--srv-md); padding: 14px;
        background: var(--srv-primary-soft);
        border-radius: var(--srv-r);
        font-size: 13px; color: var(--srv-on-variant);
    }
    .srv-ident-note i { font-size: 20px; color: var(--srv-primary); flex-shrink: 0; }
</style>
